export function Actions({ children }: { children: React.ReactNode }) {
  return <div className="flex flex-col gap-2 my-4">{children}</div>;
}
